import API from "../../../../config/api";
export default {
    data() {
        return {
            byCondition: {
                // datePicker: {
                // 	value: undefined,
                // },
                select: { //选择器
                    value: [0,1,2,3],
                    multiple: true,   //多选
                    options: [{
                        value: 0,
                        label: '变量个数'
                    }, {
                        value: 2,
                        label: '变量历史值'
                    }, {
                        value: 3,
                        label: '短信条数'
                    }, {
                        value: 1,
                        label: '公司年费'
                    }],
                    placeholder: '请选择产品名称'
                },
                table: { //表格的表头
                    data: [],
                    columns: [{
                        label: '产品名称',
                        prop: 'title',
                        width: 120,
                    },
                        {
                            label: '购买数量',
                            prop: 'chargeCount',
                            width: 360,
                        },
                        {
                            label: '花费金额',
                            prop: 'money',
                            width: 120,
                        },
                        {
                            label: '购买时间',
                            prop: 'createTime',
                        },
                    ],
                    loading: false,
                    currentPage: 1,
                    total: 0,
                    pageSize: 10,
                },
            },
            transactionRecords:[],
        }
    },
    mounted() {
        this.getConditionOrder()
    },
    methods: {
        async getConditionOrder() { //数据总览中我的订单的数据库选择器用到
            this.byCondition.table.loading = true

            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }

            let data = {
                companyId: this.companyId,
                type:this.byCondition.select.value.join(','),
                pageNum: this.byCondition.table.currentPage,
                pageSize: this.byCondition.table.pageSize
            }
            console.log(data)
            this.$axiosRequest({
                url: API.getTransactionRecords,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    console.log(res.data)
                    this.byCondition.table.data = res.data["transactionRecords"]
                    this.byCondition.table.total =  res.data.total
                    this.byCondition.table.loading = false

                }
            });
        }
    }
}
